export const ASSISTANT_PERMISSION_KEYS = {
  ASSIGN_TECHNICIANS: "assign_technicians",
  REGISTER_LAB_ENTRY: "register_lab_entry",
  MANAGE_OPERATIONS: "manage_operations",
  CHANGE_INSTRUMENT_CLIENT: "change_instrument_client",
  SET_OS_START_SEQUENCE: "set_os_start_sequence",
  DELETE_INSTRUMENTS: "delete_instruments",
  DELETE_PURCHASE_ORDERS: "delete_purchase_orders",
  DELETE_REMITOS: "delete_remitos",
};

export const ASSISTANT_PERMISSION_OPTIONS = [
  {
    key: ASSISTANT_PERMISSION_KEYS.ASSIGN_TECHNICIANS,
    label: "Asignar técnicos",
    description: "Permite asignar o cambiar el técnico de una orden.",
  },
  {
    key: ASSISTANT_PERMISSION_KEYS.REGISTER_LAB_ENTRY,
    label: "Bajar instrumentos al laboratorio",
    description: "Permite registrar la fecha de ingreso al laboratorio.",
  },
  {
    key: ASSISTANT_PERMISSION_KEYS.MANAGE_OPERATIONS,
    label: "Gestionar operaciones",
    description: "Permite modificar prioridad, estado, vencimiento y notas operativas.",
  },
  {
    key: ASSISTANT_PERMISSION_KEYS.CHANGE_INSTRUMENT_CLIENT,
    label: "Cambiar empresa o sucursal",
    description: "Permite reasignar un instrumento a otra empresa o sucursal.",
  },
  {
    key: ASSISTANT_PERMISSION_KEYS.SET_OS_START_SEQUENCE,
    label: "Modificar número inicial de OS",
    description: "Permite cambiar la numeración inicial de los instrumentos de una orden.",
  },
  {
    key: ASSISTANT_PERMISSION_KEYS.DELETE_INSTRUMENTS,
    label: "Quitar o eliminar instrumentos",
    description: "Permite desvincular instrumentos de una OS y eliminar instrumentos maestros.",
  },
  {
    key: ASSISTANT_PERMISSION_KEYS.DELETE_PURCHASE_ORDERS,
    label: "Eliminar OS/OC vacías",
    description: "Permite borrar una orden únicamente cuando no contiene instrumentos.",
  },
  {
    key: ASSISTANT_PERMISSION_KEYS.DELETE_REMITOS,
    label: "Eliminar remitos",
    description: "Permite eliminar la cabecera y los ítems de un remito.",
  },
];
